import { ReactNode } from 'react';
import { HubProvider } from '@/contexts/HubProvider';
import { HubSetter } from '@/components/HubSetter';

interface AuthenticatedLayoutProps {
  children: ReactNode;
}

export function AuthenticatedLayout({ children }: AuthenticatedLayoutProps) {
  return (
    <HubProvider>
      <HubSetter />
      {children}
    </HubProvider>
  );
}
